import { Injectable, EventEmitter } from '@angular/core';
import { LocationInterface } from '../interfaces/location-interface';
import { ShopListInterface } from '../interfaces/shop-list-interface';
import { ScriptLoaderService } from '../../core/services/scriptloader.service';

@Injectable({
  providedIn: 'root'
})
export class MapService {
  readonly pointChange: EventEmitter<LocationInterface> = new EventEmitter<LocationInterface>();
  readonly shopChange: EventEmitter<ShopListInterface> = new EventEmitter<ShopListInterface>();
  readonly mapsApiLoaded: EventEmitter<null> = new EventEmitter<null>();
  readonly onCloseMap: EventEmitter<null> = new EventEmitter<null>();

  private _loadedMap = false;
  private initMap = false;
  private siw;
  private _lastPoint: LocationInterface;

  get loadedMap() {
    return this._loadedMap;
  }

  get lastPoint() {
    return this._lastPoint;
  }

  constructor(private scriptloaderService: ScriptLoaderService) {}

  changedPoint(newPoint: LocationInterface) {
    this._lastPoint = newPoint;
    this.pointChange.emit(newPoint);
  }

  selectedShop(shop: ShopListInterface) {
    this.shopChange.emit(shop);
  }

  loadMapsApi() {
    if (!this.initMap) {
      this.initMap = true;
      this.scriptloaderService
        .load({
          name: 'map',
          src: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCWTfGsxSsi4pTW2-SZQcgB2J35tD0vU2A&libraries=places',
          loaded: false
        })
        .subscribe(async () => {
          const { default: _SNZY } = await import('snazzy-info-window');
          this.siw = _SNZY;
          this._loadedMap = true;
          this.mapsApiLoaded.emit();
        });
    }
  }

  closeMap() {
    this.onCloseMap.emit();
  }

  createInfoWindow(opts) {
    if (this.siw) {
      return new this.siw(opts);
    }
  }

  /**
   * updates centerpoint to the middle point of all shops given
   * @param shops list of shops to relative center on
   */
  centerMapOnShops(shops: Array<ShopListInterface>) {
    if (shops.length > 0 && shops[0]?.location) {
      const long = { min: shops[0].location.longitude, max: shops[0].location.longitude };
      const lat = { min: shops[0].location.latitude, max: shops[0].location.latitude };
      shops.forEach(shop => {
        if (shop.location.latitude < lat.min) {
          lat.min = shop.location.latitude;
        }
        if (shop.location.latitude > lat.max) {
          lat.max = shop.location.latitude;
        }
        if (shop.location.longitude < long.min) {
          long.min = shop.location.longitude;
        }
        if (shop.location.longitude > long.max) {
          long.max = shop.location.longitude;
        }
      });
      this.changedPoint({
        longitude: +long.min + (+long.max - +long.min) / 2,
        latitude: +lat.min + (+lat.max - +lat.min) / 2,
        address: ''
      });
    }
  }
}
